import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { MessagingService } from './core/messaging.service';
import { SEOService } from './core/seo.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true,
    host: { ngSkipHydration: 'true' }
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly isMainPage$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map((event: NavigationEnd) => event.url === '/'),
    startWith(true)
  );

  constructor(
    private ms: MessagingService,
    private seoService: SEOService,
  ) {
    this.initializeApp();
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        this.seoService.createPreloadLinkForLCP();
        this.seoService.createLinkForCanonicalURL();
      }
    })
  }

  isMainPage = toSignal(this.isMainPage$);

  async initializeApp() {
    try {
      if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
        // Wait for service worker registration
        const registration = await navigator.serviceWorker.ready;
        console.log('Service Worker is active');
        
        // Initialize Firebase messaging
        await this.ms.getToken();
        this.ms.showMessages().subscribe();
      } else {
        console.warn('Service Worker is not supported in this environment');
      }
    } catch (err) {
      console.error('Error initializing app:', err);
    }
  }
}
